/**
 * File: apps/qbench-cp/reactapp/src/Order/ReviewOrder/Styles.js
 *
 * Purpose: Provides styled-component primitives for the review-order step's row actions,
 *     totals, pricing details, and estimated-total tooltip popover.
 *
 * Scope: Order creation wizard — ReviewOrder layout primitives.
 *
 * Tags: customer-portal, orders
 *
 * Overview: Defines RowActions for the right-aligned edit/delete button row, StyledTotalSum
 *     and StyledPricingDetails for the order total and pricing-breakdown link, and Wrapper for
 *     the estimated-total explanation popover, themed via the styled-components theme palette
 *     and device breakpoints.
 *
 * Exports: RowActions, StyledTotalSum, Wrapper, StyledPricingDetails — styled-component
 *     primitives used by the ReviewOrder component.
 */

import styled from 'styled-components';
import { Stack } from 'react-bootstrap';

export const RowActions = styled.div`
	width: 100%;
	flex-direction: row !important;
	justify-content: flex-end !important;
	align-items: center !important;
	padding: 12px 8px;
`;

export const StyledTotalSum = styled.div`
	display: flex;
	flex: 1;
	align-items: flex-end !important;
	font-size: 16px;
	font-weight: 500;
	line-height: 24px;
	letter-spacing: 0.15px;

	padding: 12px 8px;
`;

export const Wrapper = styled(Stack)`
  padding: 10px;
  top: 70%;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.color.palette.text.main};
  background-color: ${({ theme }) => theme.color.palette.grey[100]};
  border: 1px solid ${({ theme }) => theme.color.palette.grey[200]};

  @media ${({ theme }) => theme.device.desktop} {
    width: 16rem;
  }
`;

export const StyledPricingDetails = styled.div`
	display: flex;
	flex: 1;
	align-items: flex-end !important;
	font-size: 16px;
	font-weight: 500;
	line-height: 24px;
	letter-spacing: 0.15px;
`;
